module.exports = __webpack_public_path__ + "static/media/social_icon_tg.d77bedb1.svg";